import React from 'react';
import { F90K, RESIGNATION_REASONS } from '../../../services/p9207Api';
import { dateToInput, inputToDate } from '../helpers';

interface Tab1Props {
  formData: Partial<F90K>;
  names: Record<string, string>;
  isEditing: boolean;
  getField: (key: keyof F90K) => F90K[keyof F90K];
  setField: (key: keyof F90K, value: F90K[keyof F90K]) => void;
  resolveSingleName: (nameKey: string, type: string, code: string) => void;
  isFieldDisabled: (key: string) => boolean;
  getFieldError: (field: string) => string | undefined;
}

const Tab1BasicInfo: React.FC<Tab1Props> = React.memo(({
  formData, names, isEditing, getField, setField, resolveSingleName, isFieldDisabled, getFieldError,
}) => {
  return (
    <div className="tab-content-inner">
      <div className="section-title">離職申請資料</div>
      <div className="form-grid form-grid-4col">
        {/* 員工代號 (alwaysDisabled) */}
        <label>員工代號</label>
        <div className="lookup-field">
          <input
            value={String(getField('f90k_11') || '')}
            disabled
            readOnly
            maxLength={8}
          />
          <span className="lookup-name">{names.employee || ''}</span>
        </div>

        {/* 擬離職日 (required, editable) */}
        <label>擬離職日</label>
        <div>
          <input
            type="date"
            value={dateToInput(getField('f90k_13') as string | null)}
            onChange={e => setField('f90k_13', inputToDate(e.target.value))}
            disabled={isFieldDisabled('f90k_13')}
            className={getFieldError('f90k_13') ? 'field-error' : ''}
          />
          {getFieldError('f90k_13') && (
            <div className="field-error-text">{getFieldError('f90k_13')}</div>
          )}
        </div>

        {/* 部門 (alwaysDisabled) */}
        <label>部門</label>
        <div className="lookup-field">
          <input
            value={String(getField('f90k_21') || '')}
            disabled
            readOnly
            maxLength={4}
          />
          <span className="lookup-name">{names.department || ''}</span>
        </div>

        {/* 到職日 (alwaysDisabled) */}
        <label>到職日</label>
        <div>
          <input
            type="date"
            value={dateToInput(getField('f90k_23') as string | null)}
            disabled
            readOnly
          />
        </div>

        {/* 職稱 (alwaysDisabled) */}
        <label>職稱</label>
        <div className="lookup-field">
          <input
            value={String(getField('f90k_22') || '')}
            disabled
            readOnly
            maxLength={4}
          />
          <span className="lookup-name">{names.position || ''}</span>
        </div>

        {/* 申請日期 (alwaysDisabled) */}
        <label>申請日期</label>
        <div>
          <input
            type="date"
            value={dateToInput(getField('f90k_12') as string | null)}
            disabled
            readOnly
          />
        </div>
      </div>

      {/* 離職原因 (Combo1 — select, editable) */}
      <div className="form-grid form-grid-2col" style={{ marginTop: 12 }}>
        <label>離職原因</label>
        <div>
          <select
            value={String(getField('f90k_14') || '')}
            onChange={e => setField('f90k_14', e.target.value)}
            disabled={isFieldDisabled('f90k_14')}
            style={{ width: 200 }}
          >
            <option value="">-- 請選擇 --</option>
            {RESIGNATION_REASONS.map(r => (
              <option key={r} value={r}>{r}</option>
            ))}
          </select>
        </div>
      </div>

      {/* 離職說明 (editbox — textarea, editable) */}
      <div className="form-grid form-grid-2col" style={{ marginTop: 12 }}>
        <label>離職說明</label>
        <div>
          <textarea
            value={String(getField('f90k_15') || '')}
            onChange={e => setField('f90k_15', e.target.value)}
            disabled={isFieldDisabled('f90k_15')}
            rows={5}
            style={{ width: '100%' }}
          />
        </div>
      </div>
    </div>
  );
});

Tab1BasicInfo.displayName = 'Tab1BasicInfo';
export default Tab1BasicInfo;
